/* Send a C2P Central link through that site's login page.
 *
 * C2P Central (WordPress + LearnDash) gates its course and lesson pages, and a
 * logged-out visitor is shown the login form with NO record of where they were
 * going - so they log in and land on the site's home page, having lost the
 * lesson someone linked them to. Its /login/ page does honour ?redirect_to=,
 * and passes an already-logged-in reader straight through without asking again,
 * so wrapping the link fixes both halves.
 *
 * This runs at RENDER time, not on save: the announcement row keeps the honest
 * URL the author pasted. When C2P Central is retired for our own LMS - or if
 * they ever make their login carry the destination itself - this whole file
 * deletes and every existing announcement is already correct.
 */

const HOSTS = new Set(['c2pcentral.com', 'www.c2pcentral.com']);

// The login page itself, verified to honour redirect_to for same-site targets.
const LOGIN_URL = 'https://c2pcentral.com/login/';

// Bouncing these through the login page is either circular or pointless.
const LEAVE_ALONE = [
  /^\/$/,
  /^\/login\/?$/,
  /^\/wp-login\.php$/,
  /^\/wp-admin(\/|$)/,
  /^\/wp-json(\/|$)/,
];

export default function c2pCentralLoginLink(href) {
  if (!href) return href;

  let url;
  try {
    // No base on purpose: a relative link is one of ours, not theirs.
    url = new URL(href);
  } catch {
    return href;
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') return href;
  if (!HOSTS.has(url.hostname.toLowerCase())) return href;
  if (LEAVE_ALONE.some((re) => re.test(url.pathname))) return href;

  // Normalise to the host the login page lives on. A session cookie set on
  // c2pcentral.com does nothing for www.c2pcentral.com, and being asked to log
  // in again on a link you already used is the exact complaint here.
  url.protocol = 'https:';
  url.hostname = 'c2pcentral.com';

  return `${LOGIN_URL}?redirect_to=${encodeURIComponent(url.toString())}`;
}
